import React, { ReactNode } from 'react';
import { COMPANY_NAME } from '../../lib/constants';

interface AuthLayoutProps {
  children: ReactNode;
  title?: string;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f2044 100%)' }}>

      {/* Left branding panel */}
      <div className="hidden lg:flex lg:w-1/2 xl:w-3/5 flex-col items-center justify-center p-12 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full opacity-10"
            style={{ background: 'radial-gradient(circle, #2563eb, transparent)' }} />
          <div className="absolute -bottom-20 -right-20 w-80 h-80 rounded-full opacity-10"
            style={{ background: 'radial-gradient(circle, #06b6d4, transparent)' }} />
        </div>

        <div className="relative z-10 text-center animate-fadeIn">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-3xl mb-8 overflow-hidden"
            style={{ background: '#ffffff', border: '1px solid rgba(255,255,255,0.3)', padding: '6px' }}>
            <img src="/assets/logos/payplus-logo.jpg" alt={COMPANY_NAME} className="w-full h-full object-contain" />
          </div>
          <h1 className="text-5xl font-black text-white mb-3 tracking-tight">
            Pay<span style={{ color: '#06b6d4' }}>+</span>
          </h1>
          <p className="text-xl text-slate-300 font-medium mb-2">Sistema Punto de Venta</p>
          <p className="text-slate-400 text-base max-w-sm mx-auto leading-relaxed">
            Gestiona recargas, paquetes, facturas y seguros desde un solo lugar
          </p>

          <div className="mt-10 flex flex-wrap gap-3 justify-center">
            {['📱 Recargas', '📦 Paquetes', '🧾 Facturas', '🛡️ Seguros'].map((f, i) => (
              <span key={i} className="px-4 py-2 rounded-full text-sm font-medium"
                style={{ background: 'rgba(255,255,255,0.08)', color: '#93c5fd', border: '1px solid rgba(255,255,255,0.12)' }}>
                {f}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Right form panel */}
      <div className="w-full lg:w-1/2 xl:w-2/5 flex items-center justify-center p-6">
        <div className="w-full max-w-md animate-scaleIn">
          <div className="rounded-2xl p-8 shadow-2xl" style={{ background: 'rgba(255,255,255,0.97)' }}>
            {/* Mobile logo */}
            <div className="flex justify-center mb-6 lg:hidden">
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-11 h-11 rounded-xl overflow-hidden"
                  style={{ background: '#ffffff', padding: '4px' }}>
                  <img src="/assets/logos/payplus-logo.jpg" alt={COMPANY_NAME} className="w-full h-full object-contain" />
                </div>
                <span className="text-2xl font-black text-slate-800">
                  Pay<span style={{ color: '#06b6d4' }}>+</span>
                </span>
              </div>
            </div>

            {children}
          </div>

          <p className="mt-6 text-center text-sm text-slate-400">
            © {new Date().getFullYear()} {COMPANY_NAME} · Todos los derechos reservados
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
